import type {
  ManualItineraryDeleteRequest,
  TransportConnection,
} from 'tripPlanner/api/types'
import ChatCruiseTransportLine from './ChatCruiseTransportLine'
import FlightTripPlanTransportLine from './FlightTripPlanTransportLine'
import { getCruiseTransportOption } from '../utils/transportOptionUtils'

interface Props {
  transport: TransportConnection
  onRefetchItinerary?: () => void
  onSendMessage?: (message: string) => void
  onDeleteTarget?: (target: ManualItineraryDeleteRequest) => Promise<void> | void
  /** Render the return leg of a booked return flight at the end of the itinerary (reversed direction). */
  reversed?: boolean
  /** Heading override (e.g. the reversed "Paris → Sydney" for the return tile). Defaults to transport.name. */
  title?: string
}

function TripPlanTransportLine(props: Props) {
  const cruiseOption = getCruiseTransportOption(props.transport)

  if (cruiseOption) {
    return (
      <ChatCruiseTransportLine
        transport={props.transport}
        option={cruiseOption}
        savedItemData={cruiseOption.savedItemData}
        onDeleteTarget={props.onDeleteTarget}
      />
    )
  }

  return <FlightTripPlanTransportLine {...props} />
}

export default TripPlanTransportLine
